<template>
  <div class="container flex " style="margin-bottom: 20px;">
    <left></left>
    <div class="live flex1 buy" style="margin-left: 20px;">
    	<div class="title">
    		购买服务
    	</div>
    	<div class="" style="padding: 30px;font-weight: bold;" v-if="list.length>0">
    		使用期限
    	</div>
      <div class="" style="padding: 30px;font-weight: bold;" v-else>
      	 无可购买数据
      </div>
    	<div class="flex" style="justify-content: center;">
    		<div class="list" v-for="item,index in list" :class="{'active':index==cindex}" @click="cindex=index">
    			<div class="month">
    				{{item.month==0?'永久':item.month+'个月'}}
    			</div>
    			<div class="discount">
    				{{item.discount*10}}折
    			</div>
    		</div>


    		<div class="height" style="height: 50vh;">

    		</div>

    	</div>
    	<div class="flex bottom algin-center"  v-if="list.length>0">
        <template v-if="list.length>0">
          <span style="color: #dd0200;margin-left: 15px;"><span class="font14"  style="color: #dd0200;">￥</span><span style="font-size: 24px;color: #dd0200;">{{obj.currentPrice.toFixed(2)}}</span></span>
          <span style="font-size: 14px;color: #999;margin-left: 15px;">￥{{obj.originalPrice}}</span>
        </template>
    		<span class="flex1"></span>
    		<span style="background-color: #df0100;color: #fff;width: 160px;display: flex;justify-content: center;align-items: center;height: 60px;cursor: pointer;" @click="handlePay()">结算</span>
    	</div>
    </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          list:[],
          cindex:-1,
          obj:Object.create(null)
      }
    },
    methods:{
      getData(){
        this.$axios.get(this.$common.serviceTime_newServiceTimeList).then((res)=>{
              if(res.data.code==1){

                  this.list=res.data.data;
                  if(this.list.length>0){
                    this.cindex=0;
                  }
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handlePay(){
        if(this.list.length==0){

          alert('无可买服务');
          return
        }
        this.$router.push('pay?serviceTimeId='+this.obj.serviceTimeId+'&price='+(this.obj.originalPrice*this.obj.discount).toFixed(2))
      }
    },
    watch:{
      cindex(val){
        this.obj=this.list[val]
      }
    },
    created(){
      this.getData()
    }
  }
</script>

<style scoped="">
  .line {
  	height: 1px;
  	background-color: #ccc;
  }
  .wechat{

  	padding: 6px;
  	background-color: #00ac00;
  	color: #fff;
  	border-radius: 6px;
  	margin-left: 15px;
  }
  .alipay  {
  	padding: 6px;
  	background-color: #007cc2;
  	color: #fff;
  	border-radius: 6px;
  	margin-left: 30px;
  }
  .rcode{
  	width: 145px;
  	height: 145px;
  }
  .list {
  	width: 150px;
  	height: 60px;
  	border: 1px solid #ccc;
  	display: flex;
  	padding-left: 0 !important;
  	justify-content: center;
  	flex-direction: column;
  	margin-right: 15px;
  	border-radius: 8px;
  	position: relative;
  	font-size: 18px;
    cursor: pointer;
  }
  .buy .active {
  	color: #4fa7ff;
  	border-color: #4fa7ff;
  }
  .buy .active::after {
  	content: '';
  	position: absolute;
  	width: 30px;
  	height: 27px;
  	background: url(../assets/img/selected.png);
  	bottom: -1px;
  	right: -1px;
  }
  .discount {
  	font-size: 12px;
  	color: #f8931f;
  	margin-top: 3px;
  }
  .bottom {
  	height: 60px;
  	background-color: #eeeeee;
  }
</style>



// WEBPACK FOOTER //
// src/components/buy.vue